import React from 'react'

import {
  Box,
  Input,
  Switch,
  Td,
  Tr,
  IconButton,
  Table,
  Tbody,
  Th,
  Thead,
} from '@chakra-ui/react'
import { SaveIcon, PencilIcon, PencilOffIcon, DeleteIcon } from 'lucide-react'

import { useContactMethodsContext } from '../../contexts/ContactMethodsContext'

const ContactMethodTableRow = ({ contactMethod }) => {
  const {
    editId,
    editName,
    editActive,
    setEditName,
    setEditActive,
    handleEdit,
    handleSave,
    handleCancel,
    handleDelete,
  } = useContactMethodsContext()
  const isEditing = editId === contactMethod.id
  const hasChanges =
    editName !== contactMethod.name || editActive !== contactMethod.is_active

  return (
    <Tr>
      <Td width='40%'>
        {isEditing ? (
          <Input
            value={editName}
            onChange={e => setEditName(e.target.value)}
            w='100%'
            minW='120px'
            h='32px'
            fontSize='md'
            autoFocus
          />
        ) : (
          <Box
            w='100%'
            minW='120px'
            noOfLines={1}
            color={contactMethod.is_active ? 'inherit' : 'gray.400'}
          >
            {contactMethod.name}
          </Box>
        )}
      </Td>
      <Td width='20%'>
        <Switch
          isChecked={isEditing ? editActive : contactMethod.is_active}
          onChange={e => setEditActive(e.target.checked)}
          colorScheme='green'
          isDisabled={!isEditing}
        />
      </Td>
      <Td width='20%'>
        {isEditing ? (
          <>
            <IconButton
              icon={<PencilOffIcon size={20} strokeWidth={1.5} />}
              size='sm'
              onClick={handleCancel}
              aria-label='Cancel edit'
              colorScheme='gray'
              variant='ghost'
              mr={2}
            />
            <IconButton
              icon={<SaveIcon size={20} strokeWidth={1.5} />}
              size='sm'
              onClick={() => handleSave(contactMethod.id)}
              colorScheme='green'
              variant='ghost'
              isDisabled={!hasChanges}
              aria-label='Save changes'
              mr={2}
            />
          </>
        ) : (
          <>
            <IconButton
              icon={<PencilIcon size={20} strokeWidth={1.5} />}
              size='sm'
              onClick={() => handleEdit(contactMethod)}
              colorScheme='blue'
              variant='ghost'
              aria-label='Edit contact method'
              mr={2}
            />
            <IconButton
              icon={<DeleteIcon size={20} strokeWidth={1.5} />}
              size='sm'
              colorScheme='red'
              variant='ghost'
              onClick={() => handleDelete(contactMethod.id)}
              aria-label='Delete contact method'
              mr={2}
            />
          </>
        )}
      </Td>
    </Tr>
  )
}

const ContactMethodTable = () => {
  const { visibleContactMethods } = useContactMethodsContext()
  return (
    <Table>
      <Thead>
        <Tr>
          <Th width='40%'>Name</Th>
          <Th width='20%'>Active</Th>
          <Th width='20%'>Actions</Th>
        </Tr>
      </Thead>
      <Tbody>
        {visibleContactMethods.map(cm => (
          <ContactMethodTableRow key={cm.id} contactMethod={cm} />
        ))}
      </Tbody>
    </Table>
  )
}

export default ContactMethodTable
